export default "__VITE_ASSET__zZOXWoPL__"